/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_Save_ButtonInputs */



/**
* | output |
* | --- |
* | "Save Metadata" |
*
* @param {Iconik_Metadata_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_save_button = /** @type {((inputs?: Iconik_Metadata_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Save Metadata")
	if (locale === "de") return /** @type {LocalizedString} */ ("Save Metadata")
	if (locale === "it") return /** @type {LocalizedString} */ ("Save Metadata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Save Metadata")
	if (locale === "es") return /** @type {LocalizedString} */ ("Save Metadata")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Save Metadata")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Save Metadata")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Save Metadata")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Save Metadata")
	return /** @type {LocalizedString} */ ("Save Metadata")
});